import client from "../client";
import { AssetCategoryInterface } from "../../models/AssetModel/AssetCategory";

class AssetCategoriesService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/AssetCategories`;
      if (page > 0 && pageSize > 0) {
        url += `?page=${page}&pageSize=${pageSize}`;
      }
      const { data } = await client.get<AssetCategoryInterface[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/AssetCategories/getbyid/${id}`;

      const { data } = await client.get<AssetCategoryInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(customer: AssetCategoryInterface) {
    try {
      let url = `/api/AssetCategories`;

      const { data } = await client.post<AssetCategoryInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, customer: AssetCategoryInterface) {
    try {
      let url = `/api/AssetCategories/update/${id}`;

      const { data } = await client.post<AssetCategoryInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/AssetCategories/remove/${id}`;
      await client.post<AssetCategoryInterface>(url, { url: "" });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new AssetCategoriesService();
